module.exports = __webpack_public_path__ + "48381216f73e756bb2fa2fac5ea64581.svg";